import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthGuardService } from './shared/services';
import { HomeComponent } from './modules/core/dashboard/components/home/home.component';
import { DxDataGridModule, DxFormModule, DxButtonModule, DxBoxModule, DxAccordionModule } from 'devextreme-angular';
import { LoginComponent } from './modules/core/auth/components/login/login.component';
import { ResetPasswordComponent } from './modules/core/auth/components/reset-password/reset-password.component';
import { SetPasswordComponent } from './modules/core/auth/components/set-password/set-password.component';
import { ActivateAccountComponent } from './modules/core/auth/components/activate-account/activate-account.component';
import {TickerCardModule} from "./shared/components/ticker-card/ticker-card.component";

const routes: Routes = [
  {
    path: 'users',
    loadChildren: () => import('./modules/core//users/users.module').then(m => m.UsersModule),
  },
  {
    path: "contractors",
    loadChildren: () => import('./modules/system/contractors/contractors.module').then(m => m.ContractorsModule),
  },
  {
    path: "orders",
    loadChildren: () => import('./modules/system/orders/orders.module').then(m => m.OrdersModule),
  },
  {
    path: "transport-order-offers",
    loadChildren: () => import('./modules/system/transport-order-offers/transport-order-offers.module').then(m => m.TransportOrderOffersModule),
  },
  {
    path: "transport-orders",
    loadChildren: () => import('./modules/system/transport-orders/transport-orders.module').then(m => m.TransportOrdersModule),
  },
  {
    path: "square-vehicle-pickups",
    loadChildren: () => import('./modules/system/square-vehicle-pickups/square-vehicle-pickups.module').then(m => m.SquareVehiclePickupsModule),
  },
  {
    path: 'profile',
    loadChildren: () => import('./modules/core/account/account.module').then(m => m.AccountModule),
  },
  {
    path: 'home',
    component: HomeComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'reset-password',
    component: ResetPasswordComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'set-password/:identity/:token',
    component: SetPasswordComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: 'activate-account/:identity/:token',
    component: ActivateAccountComponent,
    canActivate: [ AuthGuardService ]
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true}), CommonModule, DxDataGridModule, DxFormModule, DxButtonModule, DxBoxModule, DxAccordionModule, TickerCardModule],
  providers: [AuthGuardService],
  exports: [RouterModule],
  declarations: [
    HomeComponent
  ]
})
export class AppRoutingModule { }
